import { render } from "./ModalNewEmail.vue?vue&type=template&id=ced8804a&scoped=true&ts=true"
import script from "./ModalNewEmail.vue?vue&type=script&lang=ts"
export * from "./ModalNewEmail.vue?vue&type=script&lang=ts"

import "./ModalNewEmail.vue?vue&type=style&index=0&id=ced8804a&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced8804a"]])

export default __exports__